import { Field, useField } from 'formik';
import { YES_NO, choiceBtnClass } from './helper';
import { blueCheckboxCardClass, blueCheckboxClass } from 'components/Profile/helper';

const GroupCard = ({ name, title, icon: Icon, question, prompt, items = [] }) => {
  const [{ value: answer }, , answerHelpers] = useField(`answers.${name}`);
  const [{ value: picked }, , pickedHelpers] = useField(name);

  const selectedNames = items.filter(({ id }) => picked?.[id]).map(({ attributes }) => attributes.name);

  const handleAnswer = (value) => {
    answerHelpers.setValue(value);

    if (!value) pickedHelpers.setValue(Object.fromEntries(items.map(({ id }) => [id, false])));
  };

  const subtitle = answer === false
    ? 'None — nothing to add'
    : selectedNames.length
      ? selectedNames.join(', ')
      : answer
        ? prompt
        : question;

  return (
    <div className={`rounded-xl border transition-colors ${answer ? 'border-blue-200 bg-blue-50/40' : 'border-gray-200 bg-white'}`}>
      <div className="flex flex-wrap items-center gap-3 p-3.5">
        <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border ${answer ? 'border-blue-200 bg-blue-50 text-blue-500' : 'border-gray-200 bg-gray-50 text-gray-400'}`}>
          <Icon size={18} />
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold text-base-content">{title}</p>
          <p className="truncate text-[13px] text-gray-400">{subtitle}</p>
        </div>

        <div className="flex w-full shrink-0 gap-2 sm:w-auto">
          {YES_NO.map(({ label, value }) => (
            <button
              key={label}
              type="button"
              aria-pressed={answer === value}
              onClick={() => handleAnswer(value)}
              className={choiceBtnClass(answer === value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {answer && (
        <div className="animate-slide-up mx-3.5 border-t border-base-200 py-3.5">
          <p className="mb-3 text-xs font-semibold text-gray-500">
            Tick everything that applies — not listed? Add it under{' '}
            <span className="text-base-content">Anything Else</span> below.
          </p>

          {items.length ? (
            <div className="grid gap-2.5 sm:grid-cols-2">
              {items.map(({ id, attributes }) => (
                <label
                  key={id}
                  className={`flex cursor-pointer items-center gap-3 rounded-xl border border-base-300 bg-white px-3.5 py-2.5 transition-colors ${blueCheckboxCardClass}`}
                >
                  <Field
                    type="checkbox"
                    name={`${name}.${id}`}
                    className={`checkbox checkbox-sm [--chkfg:white] border-gray-300 ${blueCheckboxClass}`}
                  />
                  <span className="text-[13px] font-medium">{attributes.name}</span>
                </label>
              ))}
            </div>
          ) : (
            <p className="text-xs text-gray-400">Nothing to pick from here — describe it under Anything Else below.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default GroupCard;
